module.exports = __webpack_public_path__ + "img/helm_of_the_dominator_2.66e800f0.png";